export default {
  /* Global */
  documentation: 'Documentation',
  copied: 'Successfully Copied.',
  copyFailed: 'Copy failed.',
  login: 'Log in',
  logout: 'Log out',
  privacyPolicyConfirmation:
    "Please confirm you've read and understood our Privacy Policy on data use and protection.",

  /* MainNavigation */
  onboarding: 'Onboarding',
  products: 'Products',
  governance: 'Governance',
  organizations: 'Organizations',
  organization: 'Organization',
  reports: 'Reports',
  compute: 'Compute',
  myProducts: 'My products',
  productSpecification: 'Product Specification',
  order: 'Order',
  freeTrial: 'Free Trial',
  caas: 'CaaS',
  myClusters: 'My Clusters',
  baremetal: 'BareMetal',
  helpFeedback: 'Support & Feedback',

  /* Product Specification pages (Compute/CaaS/BareMetal markdown pages) */
  caasLogoAlt: 'CaaS Logo',
  computeLogoAlt: 'Compute Logo',
  computeProductSpecificationBreadcrumb: 'Compute product specification',
  bareMetalProductSpecificationBreadcrumb: 'BareMetal product specification',
  commercialProduct: 'Commercial Product',
  evaluationProductLabel: 'Evaluation Product',

  /* SidenNavigation */
  overview: 'Overview',
  users: 'Users',
  projects: 'Projects',
  juiceGroups: 'Juice Groups',
  caasCluster: 'Caas Clusters',
  onboardingUsers: 'Onboarding Users',
  tdiConnectPortal: 'TDI Connect Portal',
  profile: 'Profile',
  notifications: 'Notifications',
  security: 'Security',
  docs: 'Docs',
  help: 'Help',
  whatsNew: "What's New",
  portalDocumentation: 'Portal Documentation',
  helpAndFeedback: 'Help and Feedback',

  /* Feedback Page */
  feedbackSuccess: 'Feedback sent successfully!',
  caasupgradeSuccess: 'Upgrade initiated successfully!',
  attachmentSizeError:
    'Total file size exceeds 2MB limit. Please reduce the number or size of files.',
  feedbackTitle: 'Support & Feedback',
  feedbackDescription:
    'We value your feedback. Please share your thoughts, suggestions, or report any issues.',
  feedbackTitleField: 'Title',
  feedbackTitlePlaceholder: 'Enter feedback title',
  feedbackDescriptionPlaceholder: 'Describe your feedback',
  feedbackTitleRequiredError: 'Title is required',
  feedbackDescriptionRequiredError: 'Description is required',
  feedbackEmailRequiredError: 'Email is required',
  invalidEmailError: 'Invalid email',
  attachmentOptionalLabel: 'Attachment (Optional)',
  attachmentDescription:
    'You can attach multiple files (images, PDF, text, JSON) to support your feedback.',
  attachmentInfoText: 'Max 1MB per file, 2MB total. Accepted formats: images, PDF, text, JSON',
  openSupportAndFeedbackGuide: 'Open support and feedback guide',
  frequentlyAskedQuestions: 'Frequently Asked Questions',
  submitYourRequest: 'Submit Your Request',
  sendButton: 'Send',
  faqFormPurposeQuestion: 'What is this form for?',
  faqFormPurposeAnswer:
    'To report issues, ask questions, or share suggestions about the TDI-Connect Portal and its features.',
  faqWhenToUseQuestion: 'When should I use it?',
  faqWhenToUseAnswer:
    "Use it when something isn't working as expected, you need clarification, or you want to propose an improvement.",
  faqWhatNotToUseForQuestion: 'What should I not use it for?',
  faqWhatNotToUseForAnswer:
    'Not for security incidents, general IT problems (VPN/laptop/email), or product-specific support handled by other teams.',
  faqWhoReceivesSubmissionQuestion: 'Who receives my submission?',
  faqWhoReceivesSubmissionAnswer:
    'The TDI-Connect team (engineering, product, and portal maintainers) review and route all incoming feedback.',
  faqWhatInfoToIncludeQuestion: 'What info should I include?',
  faqWhatInfoToIncludeAnswer:
    'Describe the issue clearly, include steps to reproduce, relevant screenshots, and your project or product instance.',
  faqFeedbackUsedQuestion: 'Will my feedback be used?',
  faqFeedbackUsedAnswer:
    'Yes—every submission is reviewed and helps guide improvements to the portal.',

  /* Table */
  emptyTable: 'No records to display.',
  paginationRangeLabel: 'of',
  paginationRangeAriaLabel: 'Go to',
  paginationRowsPerPageAriaLabel: 'Select page size',
  paginationRowsPerPageLabel: 'per page',
  paginationRowsPerPageButtonAriaLabel: 'Select items per page',
  paginationSelectedAriaLabel: 'Currently selected',
  paginationPageAriaLabel: 'Current page display',

  /* Delete Modal */
  deleteMessage1: 'Are you sure you want to delete this {name}?',
  deleteMessage2: 'Type in the following to confirm: ',

  /* Sign-in Change Banner */
  signInChangeBannerTitle: 'Important: TDI Connect sign-in has changed',
  signInChangeBannerText:
    "Sign in using your new corporate email address. Select Sign in, enter your full email, and follow your company's sign-in steps, including any verification prompts. Having trouble signing in? Submit a request through the Support form.",
  signInChangeBannerLink: 'Support form',

  /* Cookie Banner */
  cookieBannerTitle: 'Cookie Usage',
  cookieBannerCheckboxMessage1:
    'By checking this box, you confirm that you have read & understood our ',
  cookieBannerCheckboxMessage2:
    ', which explains how we collect, use, and protect your personal data.',

  /* Home Page */
  title: 'TDI Connect',
  iaasDescription:
    'Empower IT & Telco with Cloud Services for Scalable, Efficient Operations Across Europe',
  computeTitle: 'Compute',
  computeSubheader: 'Scalable Compute for Any Workload',
  computeDescription:
    'Effortlessly deploy and scale high-performance compute resources in the cloud. Designed for demanding workloads like AI, data processing, and simulation — with fast provisioning, flexible pricing, and global availability.',
  computeButtonText: 'Read the Compute specs',
  caasTitle: 'CaaS',
  caasSubheader: 'Container as a Service',
  caasDescription:
    'Offers a managed environment for deploying and scaling containerized applications using Kubernetes clusters via API. Supports CaaS on OpenStack (VM-based clusters) or BareMetal (dedicated physical server clusters).',
  caasButtonText: 'Read the CaaS specs',
  marketPlaceText: 'Our Marketplace',
  /* api key */
  apiKeyGenerated: 'API key successfully generated',
  apiKeyGenerationErr: 'API key generation failed',
  apiKeyCopy1: 'Please copy this API key and store it in a safe place.',
  apiKeyCopy2: 'You will not be able to see it again.',

  /* users */
  userActivated: 'User was successfully activated.',
  userPasswordChanged: 'Password was successfully changed.',
  userPasswordMismatch: 'Passwords do not match.',
  userPasswordResetEmail: 'Your password reset email has been sent.',
  userPasswordReset: 'User password was successfully saved. Now you can log in.',
  cloudPasswordUpdate: 'Cloud password was successfully updated.',
  userCreation: 'User was successfully created.',
  userDeleted: 'User was successfully deleted.',
  userUpdated: 'User was successfully updated.',
  userDeletePermissionErr: "You don't have a permission to delete this user.",
  userEditPermissionErr: "You don't have a permission to edit this user.",
  userUnassignment1: 'This user is assigned to the following products:',
  userUnassignment2: 'By proceeding, the user will be unassigned from these products.',
  userPendingOrgAssignment:
    'This user has not yet been assigned to an organization. Editing is unavailable until organization assignment is complete.',
  userOnboardingRequired:
    'This user has not yet completed onboarding. Editing is unavailable until onboarding is complete.',
  userRoleManagedExternally:
    'Role updates are not allowed here - role is managed outside our domain.',
  incorrectToken: 'Incorrect token',
  userActivationErr: 'User activation failed',
  userCreationPermissionErr: "You don't have the permission to create a new user.",

  /* organizations */
  organizationCreation: 'Organization was successfully created.',
  organizationUpdated: 'Organization was successfully updated.',
  organizationCreationPermissionErr: "You don't have the permission to create a new organization.",
  editOrganizationDisabled: "You don't have the permission to edit this organization.",

  /* osprojects */
  createOsProjectFulfilled:
    'We are preparing your product in the data center. This operation will take a few minutes. You will be notified when the product is ready, and the service status will be shown as active. You can access all your active products (OpenStack projects) with one password per data center. This data center password is sent to you by e-mail when you create your first product (OpenStack project) in a respective data center. In case you did not receive an e-mail with a password, or you forgot your data center password, you can easily restore it in the portal (under Settings) – or contact our support team.',
  osProjectNameDuplicate: 'This project name is already in use in the selected cloud',
  osProjectDeleted: 'Deletion succesfully started',
  osProjectSetDeleted: 'Succesfully Deleted OsProject',
  osProjectPatchFailed: 'Unable to set OsProject to deleted',
  osProjectDeleteDisabled:
    "You don't have rights to set this OsProject to deleted. Please contact an admin user.",
  osProjectDeleteDisabledCreatedFromJuice:
    'This osproject was created from juice and cannot be deleted.',
  osProjectsDeleteMessage: 'If you delete this Os Project, it will also be deleted from OpenStack.',

  /* projects */
  projectCreation: 'Project was successfully created.',
  projectDeleted: 'Project was successfully deleted.',
  projectEdit: 'Project was successfully updated.',
  noUsageData: 'There is no usage data.',
  projectCreationPermissionErr: "You don't have the permission to create a new project.",
  adminOrgActionDisabled: 'Not allowed in admin-org',
  editProjectDisabled: "You don't have the permission to edit this project.",
  deleteProjectPermissionErr: "You don't have the permission to delete this project.",
  projectDeleteDisabled: 'Project cannot be deleted.',
  projectDeleteDisabledHasProducts: 'Cannot delete project with existing products.',

  /* products */
  productForecasts: 'Product {name} forecasts',
  productCreationPermissionErr: "You don't have the permission to create a new product.",
  evaluationProductCreationDisabled: "You can't create new evaluation product.",
  productCreation: 'Product was successfully created.',
  productUpdated: 'Product was successfully updated.',
  productDeleted: 'Product was successfully deleted.',
  productDeleteDisabled: "You don't have rights to delete this product. Please contact admin user",
  productDeleteUndoable: "This type of product can't  be deleted.",
  productDeleteDisabledOsProjects: 'There are existing OsProjects in this product',
  productDeleteDisabledCaasClusters: 'There are existing CaaS Clusters in this product',
  productDeleteDisabledCaasBm: 'Product with type caasonbaremetal is not deletable',
  editProductDisabled: "You don't have the permission to edit this product.",
  productDeleteMessage:
    'If you delete this product, the juice group associated with it will also be deleted.',

  /* Compute Order Text for Project and Resource Allocation */
  projectName: 'A user-friendly name identifying the OS Project.',
  projectDescription:
    'The initiative or activity of your organization. Projects can be created only by Admins.',
  productDescription:
    'Child of a Project that requires you to instantiate cloud resources. Products can be created only by Admins.',
  dataCenterDescription:
    'TDI-operated data centers in Europe, compliant with DT standards and organized in a geo-redundant location concept.',
  virtualCPUsAndMemory:
    'Amounts to be allocated to your OpenStack project. The vCPUs are offered with a standard processing performance. In case you require high performance processing, please reach out to our support team.',

  /* forecasts */
  forecastsNotFound:
    'There is no information in forecast DB for this Juice Group, you cannot create virtual cloud for this project.',
  forecastsApplySuccess: 'Forecast(s) are successfully applied',
  forecastsApplyFailure: 'Forecast(s) applying failed',

  /* juiceGroup  info */
  editJuiceGroupInfo: 'Edit JuiceGroup info',
  geoRedundancySet: 'Geo redundancy was successfully set',
  serviceAdded: 'External service was successfully added',
  serviceRemoved: 'External service was successfully removed',

  /* contact info */
  contactAdded: 'Contact information was successfully added',
  contactEdited: 'Contact information was successfully updated',
  contactRemoved: 'Contact information was successfully removed',
  contactCreateDisabled: "You don't have rights to create contact",
  contactEditDisabled: "You don't have rights to edit contact",
  contactDeleteDisabled: "You don't have rights to delete contact",

  /* Notification Messages */
  duplicateContactValidation: 'A contact with this email and role already exists',

  /* Errors (app-specific - generic HTTP/backend error codes come from
     @piaas/piaas-ui-toolkit/i18n, merged in ../en.ts) */
  ERR_USER_DELETION_NOT_ENTITLED: "User doesn't have rights to delete that user role",
  ERR_NAME_INVALID:
    'Name must contain only lowercase letters, numbers, and hyphens (e.g., my-project)',
  ERR_ORG_NAME_INVALID:
    'Organization name must contain only lowercase letters, numbers, and hyphens (e.g., my-org)',
  ERR_PASSWORD_INVALID:
    'Your password should have at least, 10 characters, 1 uppercase, 1 lowercase, 1 digit and 1 special character (no space).',
  ERR_PASSWORD_DUPLICATE: 'You cannot re-use the current password',
  ERR_EMAIL_FAILED: 'User creation failed',
  ERR_MARKETPLACE_ITEM_NOT_ENABLED: 'Marketplace item not enabled',
  ERR_EXISTING_PRODUCTS: 'Cannot proceed because of existing products',
  ERR_EXISTING_TENANT: 'Cannot proceed because of existing tenants',
  ERR_ITEM_ALREADY_ACTIVATED: 'The selected marketplace item is already active',
  ERR_JUICEGROUP_INVALID_LENGTH: 'The Juice Group name must be between 3 and 64 characters',
  ERR_JUICEGROUP_INVALID: 'The Juice Group Name is invalid',
  ERR_SCIM_UNSUPPORTED_SYNTAX: 'Unsupported SCIM filter syntax',
  ERR_MARKETPLACE_ITEM_NOT_ALLOWED: 'Marketplace item is not allowed for this organization',
  ERR_ADMIN_EXISTS: 'An admin user already exists for this organization',

  /* Onboarding */
  onboardingWelcomeTitle: 'Welcome to TDI Connect',
  onboardingWelcomeDescription:
    'Your identity has been verified via Entra ID. To complete access setup, please provide the business context below. An administrator will review your request and assign you to an organization.',
  onboardingBusinessJustificationLabel: 'Business Justification',
  onboardingBusinessJustificationPlaceholder: 'Explain why you need access to TDI Connect',
  onboardingBusinessJustificationRequired: 'Business justification is required.',
  onboardingTeamLabel: 'Team / Department',
  onboardingTeamPlaceholder: 'e.g. Platform Engineering',
  onboardingManagerLabel: 'Manager',
  onboardingManagerPlaceholder: 'Manager name or email',
  onboardingReferenceLabel: 'Reference',
  onboardingReferencePlaceholder: 'Ticket number, project name, or contact (optional)',
  onboardingEnterpriseNameLabel: 'Organization Name (if known)',
  onboardingEnterpriseNamePlaceholder: 'e.g. Deutsche Telekom AG',
  onboardingSubmissionFailed: 'Submission failed. Please try again.',
  onboardingSubmitting: 'Submitting…',
  onboardingSubmitRequest: 'Submit Request',

  /* Generic actions/labels (shared across many components) */
  submit: 'Submit',
  cancel: 'Cancel',
  save: 'Save',
  okay: 'Okay',
  delete: 'Delete',
  edit: 'Edit',
  formRequiredError: 'Required',
  optionalFieldSuffix: '(optional)',
  deleteFieldMismatch: 'Entered value should match the current {name}',
  deleteModalTitle: 'Delete {name}',
  notAvailable: 'N/A',
  removeElement: 'remove element',
  noSelection: 'No selection',
  copyToClipboard: 'Copy to clipboard',
  filter: 'Filter',
  uploadFile: 'Upload File',
  clickToUpload: 'Click to upload',
  fileSizeExceedsLimit: 'File size exceeds {size}MB limit',
  filesUploadedInfo: '✓ {count, plural, one {# file} other {# files}} uploaded ({size} KB total)',
  tagsLabel: 'Tags',
  noTagsAvailable: 'No tags available',
  search: 'Search',
  apply: 'Apply',
  clear: 'Clear',
  openHelpGuide: 'Open help guide',
  initializing: 'Initializing...',
  copyrightText: '© DT Europe Holding GmbH',
  contact: 'Contact',
  termsAndConditions: 'Terms and conditions',
  imprint: 'Imprint',
  dataPrivacy: 'Data Privacy',
  scrollToTop: 'Scroll to top',
  switchToMonthView: 'Switch to month view',
  goToNextMonth: 'Go to next month',
  goToPreviousMonth: 'Go to previous month',
  switchToYearView: 'Switch to year view',

  /* Role labels */
  roleLabelAdmin: 'Admin',
  roleLabelTdiConnectAdmin: 'TDI Connect Admin',
  roleLabelSupport: 'Support',
  roleLabelTdiConnectSupport: 'TDI Connect Support',
  roleLabelCaasAdmin: 'CaaS Admin',
  roleLabelTdiConnectCaasAdmin: 'TDI Connect CaaS Admin',
  roleLabelAccountOwner: 'Account Owner',
  roleLabelTdiConnectAccountOwner: 'TDI Connect Account Owner',
  roleLabelAccountAssistant: 'Account Assistant',
  roleLabelTdiConnectAccountAssistant: 'TDI Connect Account Assistant',
  roleLabelTechnicalLead: 'Technical Lead',
  roleLabelTdiConnectTechnicalLead: 'TDI Connect Technical Lead',
  roleLabelDeveloper: 'Developer',
  roleLabelTdiConnectDeveloper: 'TDI Connect Developer',
  roleLabelUnknown: 'Unknown',

  /* Governance / Organizations (shared table column labels) */
  email: 'Email',
  role: 'Role',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  usersGuideAriaLabel: 'Open users guide',
  organizationsGuideAriaLabel: 'Open organizations guide',
  usersGuide: 'Users guide',
  organizationsGuide: 'Organizations guide',
  marketplace: 'Marketplace',
  createdBy: 'Created by',

  /* Overview tables (shared row title labels) */
  crmId: 'CRM ID',
  accountOwner: 'Account owner',
  description: 'Description',
  type: 'Type',
  project: 'Project',
  juiceGroup: 'Juice Group',
  approved: 'Approved',
  name: 'Name',
  clusterType: 'Cluster Type',
  clusterVersion: 'Cluster Version',
  cloud: 'Cloud',
  deviceCount: 'Device Count',
  owner: 'Owner',
  created: 'Created',
  lastUpdated: 'Last Updated',
  kubeConfig: 'KubeConfig',
  technicalLead: 'Technical lead',
  cloudId: 'Cloud Id',
  geoRedundancy: 'Geo-Redundancy',
  externalServices: 'External Services',
  phone: 'Phone',
  slack: 'Slack',
  devProjectName: 'Dev. Project Name',
  openStackUserName: 'OpenStack User Name:',
  openStackWorkingSourceFile: 'OpenStack working source file:',
  horizonUrl: 'Horizon URL:',

  /* Onboarding/Account/Error pages */
  onboardingUnavailable: 'Onboarding is temporarily unavailable.',
  notificationsUnavailable: 'Notifications are temporarily unavailable.',
  changeCloudPassword: 'Change a cloud password:',
  page404Message: 'Unfortunately this page is not available.',
  backToHomepage: 'Back to homepage',
  somethingWentWrong: 'Something went wrong.',
  completingLogin: 'Completing login...',
  privacyPolicy: 'Privacy Policy',
  privacy: 'Privacy',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  accept: 'Accept',
  newPassword: 'New Password',
  retypeNewPassword: 'Retype New Password',
  secondaryNav: 'Secondary',

  /* Reports / Organizations / Projects */
  juiceGroupsHeader: 'JUICE Groups',
  juiceGroupsSubHeader: 'Select a Juice Group from the table to view its details.',
  noProductSelected: 'No product selected to configure! Please select one from the table above.',
  addNewExternalService: 'Add New External Service',
  add: 'Add',
  geoRedundancyState: 'Geo Redundancy State:',
  editJuiceGroupInfoTitle: 'Edit Juice Group Info',
  createNewContact: 'Create New Contact',
  createNewProject: 'Create New Project',
  projectSubHeader:
    'Add new projects, edit their details or select a project to configure its products.',
  createNewProduct: 'Create New Product',
  createNewOrganization: 'Create New Organization',
  editProjectTitle: 'Edit project {name}',
  editProductTitle: 'Edit product {name}',
  editOrganizationTitle: 'Edit organization {name}',
  projectNameField: 'Project Name',
  productNameField: 'Product Name',
  productTypeField: 'Product Type',
  organizationNameField: 'Organization name',
  juiceGroupTags: 'Juice Group Tags',
  validatingJuiceGroup: 'Validating Juice Group...',
  slugValidationMessage: 'All lower-case, no spaces, no special characters (dash only)',
  slugValidationMessageWithLetter:
    'Start with letter, all lower-case, no spaces, no special characters(dash only)',
  juiceGroupFormatError:
    'The Juice Group must start with a letter and contain only lower-case letters, numbers, and dashes',
  juiceGroupMinLength: 'The Juice Group must be at least 3 characters long',
  juiceGroupMaxLength: 'The Juice Group must be at most 64 characters long',
  cloudSummaries: 'Cloud Summaries',
  productForecast: 'Product Forecast',
  productSettingsSubHeaderAdmin: 'Configure the setting for this product.',
  productSettingsSubHeaderReadOnly: 'Current product settings (view-only)',
  quota: 'Quota',
  vCPU: 'vCPU',
  ramGb: 'RAM (GB)',
  volumesGb: 'Volumes (GB)',
  objectStorageGb: 'Object Storage (GB)',
  floatingIps: 'Floating IPs',
  currentAllowed: 'Current allowed',
  currentAllocated: 'Current allocated',
  storageGb: 'Storage (GB)',
  cnType: 'CN Type',
  rootDiscGb: 'Root Disc (GB)',
  standardStorageGb: 'Standard Storage (GB)',
  cpuVendor: 'CPU Vendor',
  serverCount: 'Server #',
  storageVolumeGb: 'Storage Volume (GB)',
  vCPUShared: 'vCPU (Shared)',
  vCPUDedicated: 'vCPU (Dedicated)',
  ramSharedGb: 'RAM (Shared)(GB)',
  ramDedicatedGb: 'RAM (Dedicated)(GB)',
  rootDiskLocalGb: 'Root disk local (GB)',
  rootDiskGb: 'Root disk (GB)',
  forecastSummaryHeading: 'Forecast Summary',
  virtualCloudSummaryHeading: 'Virtual Cloud Summary',
  usageSummaryHeading: 'Usage Summary',

  /* Products / Compute */
  computeOsProjectOrdered: 'Compute OS-Project Ordered',
  projectLabel: 'Project: ',
  productLabel: 'Product: ',
  dataCenterLabel: 'Data Center: ',
  projectNameLabel: 'Project Name: ',
  osProjectName: 'OS Project Name',
  osProjectNamePlaceholder: 'Enter a name for your Openstack Project',
  copyWorkingSourceFile: 'Copy working source file',
  configuration: 'Configuration',
  evaluationExpired: 'Your right to use the free trial product has expired.',
  evaluationNotEnabled: 'Trial product is not enabled for your organization.',
  evaluationNotAssigned: 'You are not assigned to trial product.',
  evaluationOsProjectOrdered: 'Evaluation OS-Project Ordered',
  projectDescriptionTitle: 'Project Description',
  evaluationProductTitle: 'Evaluation product',
  evaluationFreeOfCharge: '(Free of charge)',
  evaluationDescriptionIntro:
    'The evaluation product enables user to place workloads on the pan-net.cloud using Cloud APIs and a full set of user documentation. The product includes 10 vCPUs, 10GB RAM and 10GB storage. The product is available for a 3 month testing period starting from order confirmation. An organization can order 1 evaluation products in total within a time frame of one year starting from the creation of the organization in the pan-net.cloud portal.',
  evaluationDescriptionGtc:
    'This product is governed by the General Terms & Conditions (GT&C) for using pan-net.cloud.',
  evaluationDescriptionProductSpec:
    'The Product Specification for evaluation products is applicable as published on the pan-net.cloud portal.',
  evaluationDescriptionSla:
    'The Service Level Agreement is not applicable for evaluation products.',
  evaluationAllocatedToTrialProduct:
    'Your compute package is allocated to the trial product of your organization,',
  evaluationWillBeAllocatedToTrialProduct:
    'Your compute package will be allocated to the trial product of your organization,',
  evaluationNavigateToProducts: 'Navigate to the products page by clicking',
  evaluationClickHere: 'here',
  evaluationDefineOsProjectName: 'Define a name for the OpenStack project (tenant):',
  virtualCpusAndMemoryLabel: 'Virtual CPUs and Memory: ',
  cpuCores: 'CPU Cores',
  storageLabel: 'Storage: ',
  storageDescription:
    'Add block storage to your OpenStack project. Block storage can then be attached to the instances you create.',
  floatingIpsLabel: 'Floating IPs',
  floatingIpsDescription:
    'Using a floating IP, you can rapidly provide access from an external network to the instance with no public network interface.',
  product: 'Product',
  internetConnectivity: 'Internet Connectivity',
  dthConnectivity: 'DTH Connectivity',
  dthRedRouterConnectivity: 'DTH Red Router Connectivity',

  /* Product details (non-CaaS) */
  from: 'From',
  to: 'To',
  cloudReportDescription:
    'Activate a time period in which you would like to receive cloud reports.',
  cloudReportDownloadError: 'An error occurred while downloading the report. Please try again.',
  fromDateBeforeToDate: 'From date must be before To date',
  toDateBeforeToday: 'To date must be before or equal to today',
  toDateAfterFromDate: 'To date must be after From date',
  virtualCloudSummaries: 'Virtual Cloud Summaries',
  selectCloudForHypervisors: 'Select a cloud to see the available hypervisors',
  noVirtualCloudsFound: 'No Virtual clouds were found',
  noForecastFound: 'No Forecast was found',

  /* CaaS cluster details */
  copyKubeConfig: 'Copy KubeConfig',
  clusterNodes: 'Cluster Nodes',
  clusterNodesFetchError: 'We encountered an error while fetching cluster nodes',
  currentVersion: 'Current version',
  parent: 'Parent',
  close: 'Close',
  failedToLoadClusterDetails: 'Failed to load cluster details',
  failedToLoadUpgradeStatus: 'Failed to load upgrade status',
  error: 'Error',
  failedToLoadValidationResults: 'Failed to load validation results',
  clusterCannotBeUpgradedYet: "This cluster can't be upgraded yet",
  clusterStatus: 'Cluster Status',
  clusterReroll: 'Cluster Reroll',
  machinePlans: 'Machine Plans',
  pdbs: 'PDBs',
  podsNotRunning: 'Pods Not Running',
  podsWithBitnamiImages: 'Pods with Bitnami Images',
  argoCdApplications: 'ArgoCD Applications',
  rerunValidation: 'Re-run validation',
  clusters: 'Clusters',
  failed: 'Failed',
  completed: 'Completed',
  statusRefreshFailed: 'Status refresh failed',
  statusRefreshFailedText: 'Unable to fetch latest upgrade status. Click "Refresh Now" to retry.',
  upgradeDetails: 'Upgrade details',
  targetVersion: 'Target version',
  requestor: 'Requestor',
  triggeredAt: 'Triggered at',
  upgradeProgress: 'Upgrade Progress',
  masterNodes: 'Master Nodes',
  workerGroups: 'Worker Groups',
  functions: 'Functions',
  refreshNow: 'Refresh Now',
  clusterCheckFetchError: 'Failed to fetch cluster check data',
  kubeconfigFetchError: 'Failed to fetch cluster kubeconfig',
  clusterStatusCheckModalTitle: 'Cluster Status Check: {name}',
  copy: 'Copy',
  kubeConfigModalTitle: 'KubeConfig for {name}',
  clusterStatusCheck: 'Cluster Status Check',
  upgrades: 'Upgrades',
  requestClusterUpgrade: 'Request Cluster Upgrade',
  upgradeToVersion: 'Upgrade to {version}',
  upgrade: 'Upgrade',
  upgradeInProgressSupportTextBeforeLink: "It's safe to close — you'll get a",
  notificationLinkText: 'notification',
  upgradeInProgressSupportTextAfterLink: 'when the upgrade finishes.',
  needHelp: 'Need help?',
  contactSupport: 'Contact Support',
  tryAgain: 'Try again',
  newUpgrade: 'New upgrade',
  upgradeClusterModalTitle: 'Upgrade Cluster: {name}',
  loadingClusterDetails: 'Loading cluster details…',
  upgradeStatusTitle: 'Upgrade Status',
  selectVersionToUpgrade: 'Select the version to upgrade to *',
  selectAVersion: 'Select a Version *',
  unlocksAfterValidation: 'Unlocks once pre-upgrade validation passes.',
  clusterNotEligibleForUpgrade: 'Cluster is not eligible for upgrade',
  upgradeConfirmationCheckbox:
    'I confirm that I understand the implications of upgrading this cluster and have coordinated with the necessary stakeholders *',
  preUpgradeValidation: 'Pre-upgrade validation',

  /* Product details tabs / JuiceGroup & cluster table columns */
  osProjects: 'OS Projects',
  cloudReport: 'Cloud Report',
  contacts: 'Contacts',
  version: 'Version',
  group: 'Group',
  hostname: 'Hostname',
  flavor: 'Flavor',
  cpu: 'CPU',
  memory: 'Memory',
  disk: 'Disk',
  productNameColumn: 'Product Name',
  projectNameColumn: 'Project Name',
  expirationDate: 'Expiration Date',
  export: 'Export',
  create: 'Create',
  action: 'Action',

  /* Account Security / Password pages */
  cloudPassword: 'Cloud Password',
  confirmNewPasswordField: 'Confirm new password',
  changePasswordButton: 'Change Password',
  emailAddress: 'Email address',
  genericErrorOccurred: 'An error occurred',
  passwordResetTitle: 'Password Reset',
  resetPasswordTitle: 'Reset Password',
  resetPasswordInstructions:
    'Enter your portal email address in order to receive a password reset link:',

  /* User activation / Terms */
  userActivationTitle: 'User activation',
  invitedToOrganization: 'You were invited to {organizationName}. Please create your password.',
  readAboutDtCloudServices: 'Read about DT Cloud Services',
  here: 'here',
  termsIntroBeforeLink:
    'By accessing this web portal, You explicitly confirm and acknowledge that You are officially authorized and designated as " IaaS " user to represent Your Employer Company (as "Service Receiver"), whilst undertaking activities in accordance to the General Terms and Conditions given on the following',
  generalTermsAndConditionsLinkText: 'General Terms and Conditions',
  termsIntroAfterLink: 'which must be explicitly accepted by You as requested below.',
  termsSecondParagraph:
    'Prior accepting the above stated General Terms and Conditions and Agreement on the Processing of Personal Data, please read it carefully and make sure that you understand the terms, conditions and provisions thereof, since by accepting these terms and conditions, You expressly agree to apply thereof when evaluating "IaaS".',
  termsThirdParagraphBeforeLink:
    'By accepting the above stated General Terms and Conditions, please be informed that on the following',
  termsThirdParagraphAfterLink:
    'you will find our "Data privacy information for DT Cloud Services portal", for your own informative purposes and awareness, only.',

  /* Error pages */
  thankYouForYourInterest: 'Thank you for your interest!',
  checkAddressAndRetry: 'Please check the address and try again.',
  apologies: 'Apologies.',
  weAreWorkingOnIt: 'We are working on it.',
  tokenExpiredTitle: 'Something Went Wrong!',
  tokenExpiredMessage:
    'Your link has reached expiration time, sadly. Please restart the operation.',
  tokenExpiredContactSupport: "If you can't do this properly please contact our support team.",

  /* Cookie Banner */
  partnerList: 'Partner List (2)',

  /* Users (OrganizationDetails) */
  createNewUser: 'Create New User',
  editUserTitle: 'Edit user: {email}',

  /* CaaS cluster upgrade progress */
  functionsStatus: 'Functions Status',
  allFunctionsCompleted: 'All functions completed',
  waiting: 'Waiting',
  loadingLabel: 'Loading {label}',
  issuesCount: '{count, plural, one {# issue} other {# issues}}',
  allHealthy: 'all healthy',
  showLess: 'Show less',
  showMore: 'Show {count} more',
  runningLabel: 'Running',
  passed: 'Passed',
  pendingLabel: 'Pending',
  platformFunctionsPhase: 'Platform functions',
  postUpgradeCheckPhase: 'Post-upgrade check',
  doneLabel: 'Done',
  progressingLabel: 'Progressing',
  readyLabel: 'Ready',
  postUpgradeCheckFailedTitle: 'Post-upgrade check failed',
  postUpgradeCheckFailedTextWithVersion:
    'The cluster was upgraded to {version}, but the automated post-check did not pass. Verify the cluster manually before relying on it.',
  postUpgradeCheckFailedTextNoVersion:
    'The cluster was upgraded, but the automated post-check did not pass. Verify the cluster manually before relying on it.',
  upgradeCompleteTitle: 'Upgrade complete',
  upgradeCompleteText: 'The cluster is now running {version} and passed the post-upgrade check.',
  theNewVersionFallback: 'the new version',
  upgradingTitle: 'Upgrading',
  upgradingTitleWithVersion: 'Upgrading to {version}',
  upgradeInProgressBannerText:
    'This can take a while. It keeps running even if you close this dialog.',
  liveLabel: 'Live',
  noUpgradeRunning: 'No upgrade is running',
  nodeWorkerDetailTitle: 'Node & worker detail',
  waitingForPlatformFunctions: 'Waiting for platform functions',

  /* Compute order form validation */
  spacesNotAllowed: 'Spaces not allowed',
  exceedsAvailableQuota: 'Exceeds available quota',
  mustBeGreaterThanZero: 'Must be greater than 0',
  mustBeZeroOrGreater: 'Must be 0 or greater',

  /* Compute order form */
  enterResourceAvailable: 'Enter {label} ({available} available)',
  ramLabel: 'RAM',
  diskQuotaLabel: 'Disk Quota',
  diskQuotaGb: 'Disk Quota (GB)',
  resourceNotAvailableSingular: '{resourceList} is not available and is required to proceed',
  resourceNotAvailablePlural: '{resourceList} are not available and are required to proceed',
  resourceCalculationInstructions:
    'Calculate the total number of needed resources by adding up the resources of the instances that you plan to deploy. The list of available instance types can be found',
  dthConnectivityWithInternetRedRouter: 'DTH Connectivity with Internet (Red Router)',
  noVirtualCloudsForProduct: 'No virtual clouds available for selected product',
  noProductsForProject: 'No products available for selected project',
  noProjectsAvailable: 'No projects available',

  /* Sidebar navigation header */
  telecomLogoAlt: 'telecom logo T',
  tdiConnectLogoAlt: 'TDI Connect Logo',

  /* Compute order page */
  openstackProjectRequest: 'Openstack Project Request',

  /* Compute order - Network Connectivity */
  internetConnectivityDescription:
    'This option includes the demanded (predefined) number of public floating IPs, the creation of an internal network and the creation of a virtual router configured for internet connectivity.',
  internetConnectivityDisabledDescription:
    'In case this option is disabled, only the demanded floating IPs are provided, and no networks or routers are created. Internet connectivity can be configured using JUICE API at a later stage',
  dthConnectivityDescription:
    'This option includes the demanded (predefined) number of DTH floating IPs, the creation of an internal network and the creation of a virtual router configured for DTH connectivity.',
  dthConnectivityDisabledDescription:
    'In case this option is disabled, only the demanded floating IPs are provided, and no networks or routers are created. DTH connectivity can be configured using JUICE API at a later stage as well.',
  dthRedRouterConnectivityDescription:
    'This option includes the demanded (predefined) number of DTH floating IPs, the creation of an internal network, the creation of a virtual router configured for DTH and internet connectivity.',
  dthRedRouterConnectivityDisabledDescription:
    'In case this option is disabled, only the demanded floating IPs are provided, and no networks or routers are created. DTH and internet connectivity can be configured using JUICE API at a later stage as well.',

  /* CaaS Clusters page */
  failedToLoadCaasClusterDetails: 'Failed to load CaaS Cluster details: {message}',
  noCaasClusterSelected: 'No CaaS Cluster selected! Please select one from the table above.',
};
